/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Status_PrintingInputs */

const vi_print_admin_status_printing = /** @type {(inputs: Print_Admin_Status_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang in`)
};

/**

* @param {Print_Admin_Status_PrintingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_status_printing = /** @type {((inputs?: Print_Admin_Status_PrintingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Status_PrintingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_status_printing(inputs)
});